import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { deepLinkingSagas } from "./sagas";

const deepLinkingModule = (): Module => ({
	id: "deepLinkingModule",
	sagas: () => [deepLinkingSagas]
});

export default deepLinkingModule;
